/* eslint-disable prefer-arrow/prefer-arrow-functions */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DateTimePipe } from 'app/core/pipes/datetimeformator.pipe';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { CustomFieldsOptions } from './custom-fields.interface';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { LightGallery } from 'lightgallery/lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatPipe } from 'app/core/pipes/dateFormat.pipe';
import { environment as env } from '../../../environments/environment';

@Component({
    selector: 'custom-fields',
    templateUrl: './custom-fields.component.html',
    styleUrls: ['./custom-fields.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CustomFieldsComponent implements OnInit {
    @Input() options: CustomFieldsOptions = {
        data: [],
        displayInColumn: 2,
        extraClass:'',
        labelAlign: 'Top'
    };
    user: any;
    lightGallery: LightGallery;
    allImages: Array<any> = [];
    allImageMap: any = {};
    settings = {
        addClass: 'checklist-light-gallery',
        counter: true,
        dynamic: true,
        dynamicEl: this.allImages,
        licenseKey: env.lightGalleryKey,
        loop: false,
        videojs: true,
        hideControlOnEnd: true,
        slideEndAnimation: false,
        download: false,
        plugins: [lgVideo]
    };
    constructor(
        public utilityService: UtilityService,
        private dateTimePipe: DateTimePipe,
        private _localStorageService: LocalStorageService,
        public translateService: TranslateService,
        public datePipe: DateFormatPipe
        ){}

    ngOnInit(): void {
        this.user = this._localStorageService.getLocalStorage('user');
    }
    isDependant(field: any): boolean{
        if(field?.is_dependent){
          const filteredOptions= this.options.data.find((element: any) => (element?.group_name === field?.group_name) && element?.label === field?.dependent_on);
          const filteredArray = filteredOptions?.value ? filteredOptions?.value?.split(',').map(item => item.trim()) : [];
          if( filteredOptions && field?.dependent_options?.every((value: any) => filteredArray.includes(value))){
            return true;
          }
        }
        else{
            return true;
        }
        return false;
    }
    hasFEAccess(field: any): boolean {
        if(field?.hide_to_fe) {
          if(this.user?.role?.role_key === 'FIELD_EXECUTIVE'){
            return false;
          }else{
            return true;
          }
        }else{
          return true;
        }
    }

    getAttachmentType(attachment: string): string {
      if (attachment) {
          const extension: string = attachment.split('.').pop();
          return this.utilityService.getAttachmentTypeEnum(extension);
      }
  };

  OnInitLightGallery = (detail: any): void => {
      this.lightGallery = detail.instance;
  };

  openLightGallery(rowData,index): void{
      this.allImages = rowData.map((data: any)=> ({src: data,name:''}));
      this.lightGallery.refresh(this.allImages);
      this.lightGallery.openGallery(index);
  }

    get applyClass(): string{
        return `grid grid-cols-${this.options.displayInColumn} ${this.options.extraClass}`;
    }

    getDateTimeValue(value): string{
        return value ? this.dateTimePipe.transformFormatedUTC(value,'YYYY-MM-DD HH:mm:ss') : null;
    }

    hasText(text: string): boolean {
        return text.split(' ')?.length > 1 ? true : false;
    }

    getInnerHtml(text): any {
        if(text){
        const openLink = this.translateService.instant('text.open_link');
        const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g;
        if(text?.match(urlRegex)?.length > 0 && this.hasText(text)){
            return text.replace(urlRegex, function(url) {
                return '<a target="_blank" href="' + url + '" class="custom-field-link">' + url + '</a>';
            });
        }
        else if(text?.match(urlRegex)?.length === 1){
            return text.replace(urlRegex, function(url) {
                return '<a target="_blank" href="' + url + '" class="custom-field-link">' + openLink + '</a>';
            });
        }
        else if(!this.utilityService.isURL(text)){
            return '<span>' +text +'</span>';
        }
      }
    else{
        return '---';
    }
    }
}
